export var IComponentType;
(function (IComponentType) {
    IComponentType["Scene"] = "Scene";
    IComponentType["Root"] = "Root";
    IComponentType["ScreenContent"] = "ScreenContent";
    IComponentType["ScreenAnchorGroup"] = "ScreenAnchorGroup";
    IComponentType["FaceLandmarkGroup"] = "FaceLandmarkGroup";
    IComponentType["Button"] = "Button";
    IComponentType["Image"] = "Image";
    IComponentType["Text"] = "Text";
    IComponentType["Text3d"] = "Text3d";
    IComponentType["Video"] = "Video";
    IComponentType["Model3d"] = "Model3d";
    IComponentType["Emitter"] = "Emitter";
})(IComponentType || (IComponentType = {}));
export var IScreenAnchorPositionType;
(function (IScreenAnchorPositionType) {
    IScreenAnchorPositionType["leftTop"] = "leftTop";
    IScreenAnchorPositionType["topMiddle"] = "topMiddle";
    IScreenAnchorPositionType["rightTop"] = "rightTop";
    IScreenAnchorPositionType["rightMiddle"] = "rightMiddle";
    IScreenAnchorPositionType["rightBottom"] = "rightBottom";
    IScreenAnchorPositionType["bottomMiddle"] = "bottomMiddle";
    IScreenAnchorPositionType["leftBottom"] = "leftBottom";
    IScreenAnchorPositionType["leftMiddle"] = "leftMiddle";
    IScreenAnchorPositionType["center"] = "center";
})(IScreenAnchorPositionType || (IScreenAnchorPositionType = {}));
export var IFaceLandmark;
(function (IFaceLandmark) {
    IFaceLandmark["origin"] = "origin";
    IFaceLandmark["eyebrowLeft"] = "eyebrowLeft";
    IFaceLandmark["eyebrowRight"] = "eyebrowRight";
    IFaceLandmark["earLeft"] = "earLeft";
    IFaceLandmark["earRight"] = "earRight";
    IFaceLandmark["eyeLeft"] = "eyeLeft";
    IFaceLandmark["eyeRight"] = "eyeRight";
    IFaceLandmark["noseBridge"] = "noseBridge";
    IFaceLandmark["noseTip"] = "noseTip";
    IFaceLandmark["noseBase"] = "noseBase";
    IFaceLandmark["lipBottom"] = "lipBottom";
    IFaceLandmark["lipTop"] = "lipTop";
    IFaceLandmark["chin"] = "chin";
})(IFaceLandmark || (IFaceLandmark = {}));
export var ITriggerTypes;
(function (ITriggerTypes) {
    ITriggerTypes["onTap"] = "onTap";
    ITriggerTypes["onFinish"] = "onFinish";
    ITriggerTypes["onLoad"] = "onLoad";
    ITriggerTypes["onMouthOpen"] = "onMouthOpen";
    ITriggerTypes["onHeadTiltLeft"] = "onHeadTiltLeft";
    ITriggerTypes["onHeadTiltRight"] = "onHeadTiltRight";
    ITriggerTypes["onHeadShake"] = "onHeadShake";
    ITriggerTypes["onTargetImageLost"] = "onTargetImageLost";
})(ITriggerTypes || (ITriggerTypes = {}));
export var IButtonCategory;
(function (IButtonCategory) {
    IButtonCategory["social"] = "social";
    IButtonCategory["text"] = "text";
    IButtonCategory["icon"] = "icon";
    IButtonCategory["iconWithText"] = "iconWithText";
    IButtonCategory["functional"] = "functional";
})(IButtonCategory || (IButtonCategory = {}));
export var IButtonSubCategory;
(function (IButtonSubCategory) {
    IButtonSubCategory["snapshot"] = "snapshot";
    IButtonSubCategory["recording"] = "recording";
})(IButtonSubCategory || (IButtonSubCategory = {}));
// Spatial Components
// Emitter
var IDistribution;
(function (IDistribution) {
    IDistribution["BOX"] = "BOX";
    IDistribution["SPHERE"] = "SPHERE";
    IDistribution["DISC"] = "DISC";
    IDistribution["LINE"] = "LINE";
})(IDistribution || (IDistribution = {}));
